export interface GeopositSuggestion {
  street?: string;
  street_number?: string;
  letter?: string;
  number_from?: string;
  number_to?: string;
  letter_from?: string;
  letter_to?: string;
  extra_number?: string;
  extra_number_from?: string;
  extra_number_to?: string;
  address_type?: string;
  postcode?: string;
  locality?: string;
  adm1_code?: string;
  adm1_name?: string;
  adm2_code?: string;
  adm2_name?: string;
  adm3_code?: string;
}

export interface GroupedResult {
  street: string;
  from: string;
  to: string;
  postcode: string;
  locality: string;
  lkfCode: string;
  county: string;
  municipality: string;
}

export interface AddressSuggestionItem {
  street: string;
  postcode: string;
  locality: string;
  streetNumber?: string;
  letter?: string;
}

function numericValue(numStr: string): number {
  const match = numStr.match(/^(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}

function numericOnly(numStr: string): string {
  const match = numStr.match(/^(\d+)/);
  return match ? match[1] : numStr;
}

export function groupSuggestions(suggestions: GeopositSuggestion[]): GroupedResult[] {
  return suggestions.map((s) => {
    const lkfCode = s.adm3_code || '';
    const extraFrom = s.extra_number_from || s.extra_number || '';
    const extraTo = s.extra_number_to || s.extra_number || '';

    const from = (s.number_from || s.street_number || '') + (s.letter_from || '');
    const to = (s.number_to || '') + (s.letter_to || '');

    return {
      street: s.street || '',
      from: from && extraFrom ? `${from}-${extraFrom}` : from,
      to: to && extraTo ? `${to}-${extraTo}` : to,
      postcode: s.postcode || '',
      locality: s.locality || '',
      lkfCode,
      county: s.adm1_name || '',
      municipality: s.adm2_name || '',
    };
  });
}

export function extractUniqueSuggestions(suggestions: GeopositSuggestion[]): AddressSuggestionItem[] {
  const seen = new Set<string>();
  const items: AddressSuggestionItem[] = [];

  for (const s of suggestions) {
    const street = s.street || '';
    const postcode = s.postcode || '';
    const locality = s.locality || '';
    const key = `${street}|${postcode}|${locality}`;

    if (!seen.has(key) && street) {
      seen.add(key);
      items.push({ street, postcode, locality });
    }
  }

  return items;
}
